<template>
  <member-list
    :memberService="memberService"
  />
</template>

<script>
import MemberList from '@/components/Common/Rental/Member/MemberList'
import memberService from '@/services/rental/member'

export default {
  components: {
    MemberList
  },
  data () {
    return {
      memberService: memberService,
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Rental/Members/Overview.vue